export const downloadBlob = (
  blob: Blob,
  filename: string,
  options?: { openInNewTab?: boolean },
): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  if (options?.openInNewTab) {
    // Open the saved file in a new tab (PDF renders inline in the browser viewer).
    window.open(url, '_blank', 'noopener');
    // Defer revocation so the new tab has time to load the blob URL.
    window.setTimeout(() => URL.revokeObjectURL(url), 60000);
  } else {
    URL.revokeObjectURL(url);
  }
};

export const safeFilenameDate = (value: string): string => value.replaceAll('-', '');
